import * as Sentry from "@sentry/react";

/**
 * start の中で同期的に始めた fetch の http.client スパンを作らない（ポーリング除外用）。
 * コールバックから Promise を返してはいけない: ブラウザの Sentry は Promise が解決するまで一時 scope を
 * スタックに残すため、その間に始まった遷移の idle span が迷子になる。
 */
export const withoutTracing = <T>(start: () => Promise<T>): Promise<T> => {
  let promise: Promise<T> | undefined;
  Sentry.suppressTracing(() => {
    promise = start();
  });
  // suppressTracing はコールバックを同期的に 1 回呼ぶ
  return promise as Promise<T>;
};
